module.exports = __webpack_public_path__ + "img/ch14_03_青禾村田野风光.50eb803b.jpg";